import {
  DEFAULT_MAT_COLOR,
  FRAME_COLORS,
  isCenterpiece,
  isCollage,
} from '@mixtiles/web-backend-shared'
import { getTileStyleData } from '../../tilesStyling'
import uniq from 'lodash/uniq'
import { isFramedMaterial } from '../../../utils/materialTypeUtils'

export function generateStyleProperties({ frameColor, matting, filter } = {}) {
  return {
    'Current Style: Matting': matting || 'Mixed',
    'Current Style: Filter': filter || 'Mixed',
    'Current Style: Frame': frameColor || 'Mixed',
  }
}

function getFrameColorProperties(tiles) {
  const frameColors = uniq(
    tiles.map((tile) => tile.customStyle?.frameColor || tile.customStyle?.color)
  )
  const isFrameless = !isFramedMaterial(tiles[0]?.materialType)
  return {
    'Current Style: Frame': isFrameless
      ? FRAME_COLORS.NONE
      : frameColors.length === 1
      ? frameColors[0]
      : 'Mixed',
    'Frame Count': isFrameless ? 1 : frameColors.length,
  }
}

export function generateSplitStyleProperties(tiles) {
  const tilesWithoutCenterpiece = tiles.filter((tile) => !isCenterpiece(tile))
  const tileStyles = tilesWithoutCenterpiece.map((tile) =>
    getTileStyleData(tile)
  )
  const mattings = uniq(tileStyles.map((tile) => tile.matting))
  const mattingColors = uniq(
    tileStyles.map((tile) => tile.mattingColor || DEFAULT_MAT_COLOR)
  )
  const filters = uniq(tileStyles.map((tile) => tile.filter))

  const collages = tilesWithoutCenterpiece.filter((tile) => isCollage(tile))
  const layouts = uniq(
    collages
      .map((tile) => tile.collage?.layout?.style)
      .filter((layout) => layout)
  )

  return {
    'Current Style: Matting': mattings.length === 1 ? mattings[0] : 'Mixed',
    'Current Style: Mat Color':
      mattingColors.length === 1 ? mattingColors[0] : 'Mixed',
    'Current Style: Filter': filters.length === 1 ? filters[0] : 'Mixed',
    'Current Style: Layout': layouts.length === 1 ? layouts[0] : 'Mixed',
    'Filters Count': filters.length,
    'Mattings Count': mattings.length,
    'Mat Color Count': mattingColors.length,
    'Layout Count': layouts.length,
    ...getFrameColorProperties(tilesWithoutCenterpiece),
  }
}

export function generateStylingProperties(item) {
  const { orderTiles, metadata } = item
  const tilesWithoutCenterpiece = orderTiles.filter(
    (tile) => !isCenterpiece(tile)
  )

  // If split styles
  if (tilesWithoutCenterpiece.every((tile) => tile.customStyle)) {
    return generateSplitStyleProperties(tilesWithoutCenterpiece)
  } else if (metadata?.style) {
    return generateStyleProperties(metadata?.style)
  }
}
